import React, { useState } from "react";
import Wrapper from "../components/Wrapper";
import { useNavigate } from "react-router-dom";
import { translations } from "../langauge.js";
import { useLang } from "../context/LanguageContext.jsx";
import MobileBottomMenu from "../components/MobileBottomMenu.jsx";
import ContactUsLink from "../components/ContactUsLink";

const Contact = () => {
  const [formData, setFormData] = useState({
    fname: "",
    lname: "",
    country: "",
    phone: "",
    email: "",
    binstagram: "",
    contacttime: "",
  });

  const { lang } = useLang();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [activeSection, setActiveSection] = useState("contact");

  const CONTACT_SECTION_IDS = ["contact", "partnerships", "investment", "integrations"];
  const sideNavItems = [
    { id: "go-back", title: translations[lang].go_back, isBack: true },
    { id: "contact", title: translations[lang].contact_us, isBack: false },
    { id: "partnerships", title: translations[lang].partnerships, isBack: false },
    { id: "investment", title: translations[lang].investment, isBack: false },
    { id: "integrations", title: translations[lang].integrations, isBack: false },
  ];
  const sectionIndex = CONTACT_SECTION_IDS.indexOf(activeSection);
  const safeSectionIndex = sectionIndex >= 0 ? sectionIndex : 0;
  const contactSectionTitles = {
    contact: translations[lang].contact_us,
    partnerships: translations[lang].partnerships,
    investment: translations[lang].investment,
    integrations: translations[lang].integrations,
  };

  const handlePrevSection = () => {
    const prevIndex = (safeSectionIndex - 1 + CONTACT_SECTION_IDS.length) % CONTACT_SECTION_IDS.length;
    setActiveSection(CONTACT_SECTION_IDS[prevIndex]);
  };
  const handleNextSection = () => {
    const nextIndex = (safeSectionIndex + 1) % CONTACT_SECTION_IDS.length;
    setActiveSection(CONTACT_SECTION_IDS[nextIndex]);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { fname, lname, country, phone, email, contacttime } = formData;
    const newErrors = {};
    if (!fname) newErrors.fname = translations[lang].please_complete_this_required_field;
    if (!lname) newErrors.lname = translations[lang].please_complete_this_required_field;
    if (!country) newErrors.country = translations[lang].please_complete_this_required_field;
    if (!phone) newErrors.phone = translations[lang].please_complete_this_required_field;
    if (!email) newErrors.email = translations[lang].please_complete_this_required_field;
    if (!contacttime) newErrors.contacttime = translations[lang].please_complete_this_required_field;
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      setErrors({});
      navigate("/success");
    }
  };

  return (
    <Wrapper>
      <div className="row">
        <div className="col-lg-3 col-md-4 col-4 rightSideDivParent">
          <div
            className="rightSideDiv"
          >
            <div className="navbarDiv">
              <ul>
                {sideNavItems.map((item) => (
                  <li key={item.id}>
                    {item.isBack ? (
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/");
                        }}
                        style={{
                          textAlign: "left",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <img
                          alt="go back"
                          src="./images/left-arrow.png"
                          style={{
                            marginRight: lang === "en" ? "15px" : 0,
                            marginLeft: lang === "ar" ? "15px" : 0,
                            height: "20px",
                            width: "auto",
                            transform: lang === "ar" ? "rotate(180deg)" : undefined,
                          }}
                        />
                        {item.title}
                      </a>
                    ) : (
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveSection(item.id);
                        }}
                        className={activeSection === item.id ? "active" : ""}
                        style={{ textAlign: lang === "ar" ? "right" : "left" }}
                      >
                        {item.title}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="col-lg-9 col-md-8 col-8 contentDivParent">
          <div className="contentDiv">
            {activeSection === "contact" && (
              <>
                <h2
                  className="aboutSectionTitle"
                  style={{ textAlign: lang === "ar" ? "right" : "left" }}
                >
                  {translations[lang].contact_us}
                </h2>
                <p
                  className="commonpara"
                  style={{ textAlign: lang === "ar" ? "right" : "left" }}
                >
                  {translations[lang].contact_us_para}
                </p>
              </>
            )}
            {activeSection === "contact" && (
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-12 d-flex flex-column gap-2 mb-4">
                    <label className="inputLabel">
                      {translations[lang].first_name} *
                    </label>
                    <input
                      type="text"
                      name="fname"
                      value={formData.fname}
                      className="commonInput"
                      onChange={handleChange}
                    />
                    {errors.fname && (
                      <span className="error">{errors.fname}</span>
                    )}
                  </div>
                  <div className="col-lg-6 col-md-6 col-12 d-flex flex-column gap-2 mb-4">
                    <label className="inputLabel">
                      {translations[lang].last_name} *
                    </label>
                    <input
                      type="text"
                      name="lname"
                      value={formData.lname}
                      className="commonInput"
                      onChange={handleChange}
                    />
                    {errors.lname && (
                      <span className="error">{errors.lname}</span>
                    )}
                  </div>
                  <div className="col-lg-6 col-md-6 col-12 d-flex flex-column gap-2 mb-4">
                    <label className="inputLabel">
                      {translations[lang].country} *
                    </label>
                    <select
                      className="commonInput commonSelect"
                      name="country"
                      value={formData.country}
                      onChange={handleChange}
                    >
                      <option value="">{translations[lang].contact_time_select}</option>
                      <option value="international">{translations[lang].country_international}</option>
                      <option value="kuwait">{translations[lang].country_kuwait}</option>
                      <option value="saudi_arabia">{translations[lang].country_saudi_arabia}</option>
                      <option value="qatar">{translations[lang].country_qatar}</option>
                      <option value="uae">{translations[lang].country_uae}</option>
                      <option value="bahrain">{translations[lang].country_bahrain}</option>
                      <option value="egypt">{translations[lang].country_egypt}</option>
                      <option value="jordan">{translations[lang].country_jordan}</option>
                      <option value="oman">{translations[lang].country_oman}</option>
                    </select>
                    {errors.country && (
                      <span className="error">{errors.country}</span>
                    )}
                  </div>
                  <div className="col-lg-6 col-md-6 col-12 d-flex flex-column gap-2 mb-4">
                    <label className="inputLabel">
                      {translations[lang].phone_number} *
                    </label>
                    <input
                      type="number"
                      name="phone"
                      value={formData.phone}
                      className="commonInput"
                      onChange={handleChange}
                    />
                    {errors.phone && (
                      <span className="error">{errors.phone}</span>
                    )}
                  </div>
                  <div className="col-lg-6 col-md-6 col-12 d-flex flex-column gap-2 mb-4">
                    <label className="inputLabel">
                      {translations[lang].email_address} *
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      className="commonInput"
                      onChange={handleChange}
                    />
                    {errors.email && (
                      <span className="error">{errors.email}</span>
                    )}
                  </div>
                  <div className="col-lg-6 col-md-6 col-12 d-flex flex-column gap-2 mb-4">
                    <label className="inputLabel">
                      {translations[lang].reason_for_inquiry} *
                    </label>
                    <select
                      className="commonInput commonSelect"
                      name="reason"
                      value={formData.reason}
                      onChange={handleChange}
                    >
                      <option value="">
                        {translations[lang].reason_for_inquiry_select}
                      </option>
                      <option value="online_ordering">
                        {translations[lang].online_ordering}
                      </option>
                      <option value="qr_menu">
                        {translations[lang].qr_menu}
                      </option>
                      <option value="pos">
                        {translations[lang].pos}
                      </option>
                      <option value="b2b_ordering">
                        {translations[lang].b2b_ordering}
                      </option>
                      <option value="booking">
                        {translations[lang].booking}
                      </option>
                      <option value="sponsored_ad">
                        {translations[lang].sponsored_ad}
                      </option>
                      <option value="partnerships">
                        {translations[lang].partnerships}
                      </option>
                      <option value="investment">
                        {translations[lang].investment}
                      </option>
                      <option value="integrations">
                        {translations[lang].integrations}
                      </option>
                      <option value="general_inquiry">
                        {translations[lang].general_inquiry}
                      </option>
                    </select>
                    {errors.reason && (
                      <span className="error">{errors.reason}</span>
                    )}
                  </div>
                  <div className="col-lg-12 col-md-12 col-12 d-flex flex-column gap-2 mb-4">
                    <label className="inputLabel">
                      {translations[lang].message}
                    </label>
                    <textarea
                      name="message"
                      value={formData.message}
                      className="commonInput"
                      onChange={handleChange}
                      maxLength={1000}
                      placeholder={`${translations[lang].message_placeholder}...`}
                      // placeholder="Tell us more about your inquiry..."
                      rows={4}
                    />
                    {errors.message && (
                      <span className="error">{errors.message}</span>
                    )}
                  </div>
                  <div className="col-lg-6 col-md-6 col-12 d-flex flex-column gap-2 mb-4">
                    <label className="inputLabel">
                      {translations[lang].business_instagram}
                    </label>
                    <input
                      type="text"
                      name="binstagram"
                      value={formData.binstagram}
                      className="commonInput"
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-12 d-flex flex-column gap-2 mb-4">
                    <label className="inputLabel">
                      {translations[lang].contact_time} *
                    </label>
                    <select
                      className="commonInput commonSelect"
                      name="contacttime"
                      value={formData.contacttime}
                      onChange={handleChange}
                    >
                      <option value="">{translations[lang].contact_time_select}</option>
                      <option value="asap">{translations[lang].contact_time_asap}</option>
                      <option value="morning">{translations[lang].contact_time_morning}</option>
                      <option value="evening">{translations[lang].contact_time_evening}</option>
                      <option value="anotherday">{translations[lang].contact_time_anotherday}</option>
                    </select>
                    {errors.contacttime && (
                      <span className="error">{errors.contacttime}</span>
                    )}
                  </div>
                </div>
                <button type="submit" className="commontSubmitbtn">
                  {translations[lang].submit}
                </button>
              </form>
            )}
            {activeSection === "partnerships" && (
              <div style={{ textAlign: lang === "ar" ? "right" : "left" }}>
                <h2 className="aboutSectionTitle">
                  {translations[lang].partnerships}
                </h2>
                <p className="commonpara">
                  {translations[lang].partnerships_intro}
                </p>
                <h3 className="aboutFeatureTitle" style={{ marginTop: "2rem" }}>
                  {translations[lang].partnerships_our_partners}
                </h3>
                <p className="commonpara">
                  {translations[lang].partnerships_payment_providers}
                </p>
                <p className="commonpara">
                  {translations[lang].partnerships_delivery}
                </p>
                <p className="commonpara">
                  {translations[lang].partnerships_pos}
                </p>
                <p className="commonpara">
                  {translations[lang].partnerships_marketing}
                </p>
                <p className="commonpara">
                  {translations[lang].partnerships_integrators}
                </p>
                <h3 className="aboutFeatureTitle" style={{ marginTop: "2rem" }}>
                  {translations[lang].partnerships_become}
                </h3>
                <p className="commonpara">
                  {translations[lang].partnerships_tech}
                </p>
                <p className="commonpara">
                  {translations[lang].partnerships_agency}
                </p>
                <p className="commonpara">
                  {translations[lang].partnerships_content}
                </p>
                <h3 className="aboutFeatureTitle" style={{ marginTop: "2rem" }}>
                  {translations[lang].partnerships_how}
                </h3>
                <p className="commonpara" dir={lang === "ar" ? "rtl" : "ltr"}>
                  {translations[lang].partnerships_how_1.split("{contactForm}")[0]}
                  <span onClick={() => setActiveSection('contact')} className="contactLink">
                    {translations[lang].contact_form}
                  </span>
                  {translations[lang].partnerships_how_1.split("{contactForm}")[1]}
                </p>
                <p className="commonpara">
                  {translations[lang].partnerships_how_2}
                </p>
                <p className="commonpara">
                  {translations[lang].partnerships_how_3}
                </p>
                <p className="commonpara">
                  {translations[lang].partnerships_how_4}
                </p>
                <h3 className="aboutFeatureTitle" style={{ marginTop: "2rem" }}>
                  {translations[lang].partnerships_already}
                </h3>
                <p className="commonpara">
                  {translations[lang].partnerships_already_desc}
                </p>
              </div>
            )}
            {activeSection === "investment" && (
              <div style={{ textAlign: lang === "ar" ? "right" : "left" }}>
                <h2 className="aboutSectionTitle">
                  {translations[lang].investment}
                </h2>
                <p className="commonpara">
                  {translations[lang].investment_intro}
                </p>
                <h3 className="aboutFeatureTitle" style={{ marginTop: "2rem" }}>
                  {translations[lang].investment_what_built}
                </h3>
                <p className="commonpara">
                  {translations[lang].investment_operating}
                </p>
                <p className="commonpara">
                  {translations[lang].investment_numbers}
                </p>
                <p className="commonpara">
                  {translations[lang].investment_architecture}
                </p>
                <h3 className="aboutFeatureTitle" style={{ marginTop: "2rem" }}>
                  {translations[lang].investment_opportunity}
                </h3>
                <p className="commonpara">
                  {translations[lang].investment_gcc}
                </p>
                <p className="commonpara">
                  {translations[lang].investment_expansion}
                </p>
                <p className="commonpara">
                  {translations[lang].investment_why_now}
                </p>
                <h3 className="aboutFeatureTitle" style={{ marginTop: "2rem" }}>
                  {translations[lang].investment_looking}
                </h3>
                <p className="commonpara">
                  {translations[lang].investment_strategic}
                </p>
                <p className="commonpara">
                  {translations[lang].investment_growth}
                </p>
                <h3 className="aboutFeatureTitle" style={{ marginTop: "2rem" }}>
                  {translations[lang].investment_contact}
                </h3>
                <p className="commonpara" dir={lang === "ar" ? "rtl" : "ltr"}>
                  {translations[lang].investment_contact_desc.split("{contactForm}")[0]}
                  <span onClick={() => setActiveSection('contact')} className="contactLink">
                    {translations[lang].contact_form}
                  </span>
                  {translations[lang].investment_contact_desc.split("{contactForm}")[1]}
                </p>
                {/* <p className="commonpara">
                  {translations[lang].investment_contact_desc}
                </p> */}
              </div>
            )}
            {activeSection === "integrations" && (
              <div style={{ textAlign: lang === "ar" ? "right" : "left" }}>
                <h2 className="aboutSectionTitle">
                  {translations[lang].integrations}
                </h2>
                <p className="commonpara">
                  {translations[lang].integrations_intro}
                </p>
                <h3 className="aboutFeatureTitle" style={{ marginTop: "2rem" }}>
                  {translations[lang].integrations_payments}
                </h3>
                <p className="commonpara">
                  {translations[lang].integrations_knet}
                </p>
                <p className="commonpara">
                  {translations[lang].integrations_apple_samsung}
                </p>
                <p className="commonpara">
                  {translations[lang].integrations_tabby}
                </p>
                <p className="commonpara">
                  {translations[lang].integrations_visa_mc}
                </p>
                <p className="commonpara">
                  {translations[lang].integrations_regional}
                </p>
                <h3 className="aboutFeatureTitle" style={{ marginTop: "2rem" }}>
                  {translations[lang].integrations_logistics}
                </h3>
                <p className="commonpara">
                  {translations[lang].integrations_armada}
                </p>
                <p className="commonpara">
                  {translations[lang].integrations_wiyak}
                </p>
                <p className="commonpara">
                  {translations[lang].integrations_paydo}
                </p>
                <p className="commonpara">
                  {translations[lang].integrations_custom_fleet}
                </p>
                <h3 className="aboutFeatureTitle" style={{ marginTop: "2rem" }}>
                  {translations[lang].integrations_pos}
                </h3>
                <p className="commonpara">
                  {translations[lang].integrations_foodics}
                </p>
                <p className="commonpara">
                  {translations[lang].integrations_grubtech}
                </p>
                <p className="commonpara">
                  {translations[lang].integrations_deliverect}
                </p>
                <p className="commonpara">
                  {translations[lang].integrations_other_pos}
                </p>
                <h3 className="aboutFeatureTitle" style={{ marginTop: "2rem" }}>
                  {translations[lang].integrations_marketing}
                </h3>
                <p className="commonpara">
                  {translations[lang].integrations_meta}
                </p>
                <p className="commonpara">
                  {translations[lang].integrations_tiktok}
                </p>
                <p className="commonpara">
                  {translations[lang].integrations_snapchat}
                </p>
                <p className="commonpara">
                  {translations[lang].integrations_google}
                </p>
                <h3 className="aboutFeatureTitle" style={{ marginTop: "2rem" }}>
                  {translations[lang].integrations_operations}
                </h3>
                <p className="commonpara">
                  {translations[lang].integrations_order_app}
                </p>
                <p className="commonpara">
                  {translations[lang].integrations_driver_app}
                </p>
                <p className="commonpara">
                  {translations[lang].integrations_dashboard}
                </p>
                <h3 className="aboutFeatureTitle" style={{ marginTop: "2rem" }}>
                  {translations[lang].integrations_request}
                </h3>
                <p className="commonpara">
                  <ContactUsLink
                    text={translations[lang].integrations_request_desc}
                    onContactFormClick={() => setActiveSection("contact")}
                  />
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      <MobileBottomMenu
        title={contactSectionTitles[activeSection] ?? translations[lang].contact_us}
        withTabs
        sectionIndex={safeSectionIndex}
        sectionCount={CONTACT_SECTION_IDS.length}
        onPrev={handlePrevSection}
        onNext={handleNextSection}
      />
    </Wrapper>
  );
};

export default Contact;
